import React from "react";
import "./DataCard.css";
import { currencyFormatter } from "../../../utils/methods";

const DataCard = ({ data, title }) => {
  let { current, target, isMonitory } = data;

  let remain = current - target;
  let formattedRemain = remain;
  let formattedCurrent = current;
  let formattedTarget = target;
  if (isMonitory) {
    formattedRemain = currencyFormatter(remain);
    formattedCurrent = currencyFormatter(current);
    formattedTarget = currencyFormatter(target);
  }

  return (
    <div className="card margin-bottom-sm data-card h-100">
      <div className="card-body">
        <div className="row align-items-center gx-0">
          <div className="col">
            <h6 className="mb-2">{title}</h6>
            <span className="h3 mb-0 bolder-text">
              {title === "Team Sales"
                ? "+" + formattedCurrent
                : formattedCurrent}
              <small className="h6 fw-bold">
                /
                {title === "Team Sales"
                  ? "+" + formattedTarget
                  : formattedTarget}
              </small>
            </span>
          </div>
          <div className="col-auto sm-full-width">
            <div className="">
              {remain >= 0 ? (
                <div className="formatted-data">
                  <h3 className="success mb-0 fw-bold">+{formattedRemain}</h3>
                  <h5 className="success text-right">Target Surpassed</h5>
                </div>
              ) : (
                <div className="formatted-data">
                  <h3 className="danger mb-0 fw-bold">{formattedRemain}</h3>
                  <h5 className="danger">To go</h5>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataCard;
